<template>
    <label>
        <div class="control">
            <input type="radio" v-bind="$attrs" :value="value" :checked="checked" v-on="listeners"/>
            <div class="input" :style="style"/>
        </div>
        <div v-if="label" class="text">{{ label }}</div>
    </label>
</template>
<script>
import Colorable from '../../mixins/Colorable';

export default {
    name: 'Radio',
    mixins: [Colorable],
    inheritAttrs: false,
    model: {
        prop: 'common',
        event: 'change',
    },
    props: {
        common: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
    },
    computed: {
        listeners () {
            return {
                ...this.$listeners,
                change: this.onChange,
            };
        },
        checked () {
            return this.value === this.common;
        },
        style () {
            return {
                borderColor: this.color,
            };
        },
    },
    methods: {
        onChange () {
            this.$emit('change', this.value);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

label {
    display: flex;
    align-items: center;

    > .control {
        flex: 0 0 auto;
        margin-right: 20px;

        // Raw input
        > input[type="radio"] {
            display: none;

            // Custom input
            + .input {
                @include square(16px);
                position: relative;
                border: 2px solid;
                border-radius: 50%;
                cursor: pointer;
            }

            &:checked + .input::before {
                content: '';
                @include square(8px);
                position: absolute;
                left: 2px;
                top: 2px;
                border-radius: 50%;
                border: inherit;
                border-width: 4px;
                box-sizing: border-box;
            }
        }
    }

    > .text {
        flex: 1 1 auto;
        text-align: left;
        color: $grey-dark;
    }
}
</style>
